import breakpoints from "@app/scripts/breakpoints.json";

//TODO: include in blankscore

export default function MediaQueries() {
	const objectMap = (obj, fn) =>
		Object.fromEntries(
			Object.entries(obj).map(
				([k, v], i) => [k, fn(v, k, i)]
			)
		)

	if(!breakpoints) return;

	const breakpointsList = objectMap(breakpoints, bp => bp.breakpoint),
				breakDown = objectMap(breakpoints, bp => bp?.breakpoint && `(max-width: ${bp.breakpoint - 1}px)`),
				breakUp = objectMap(breakpoints, bp => bp?.breakpoint && `(min-width: ${bp.breakpoint}px)`)

	const bpCheck = (bp) => {

		if(!Object.keys(breakpointsList).includes(bp)) {
			console.error(`Breakpoint "${bp}" not found. Please check the available breakpoint options in the breakpoints.json file or ask for support`);
			return false
		}

		return true;
	}

	return {
		breakpointsList,
		breakDown,
		breakUp,
		mediaBreakDown: (bp) => bpCheck(bp) && window.matchMedia(`(${breakDown[bp]})`).matches,
		mediaBreakUp: (bp) => bpCheck(bp) && window.matchMedia(`(${breakUp[bp]})`).matches,
		mediaBreakBetween: (bpUp, bpDown) => bpCheck(bpDown) && bpCheck(bpUp) && window.matchMedia(`(${breakUp[bpUp]}) and (${breakDown[bpDown]})`).matches,
	}
}
